module.exports = __webpack_public_path__ + "static/media/bf.78e1cdf6.svg";